import { useDrawerCheckout } from 'hooks/useDrawerCheckout';
import React, { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import { usePurchaseExtraSuggestedTruckers } from 'hooks/usePurchaseExtraSuggestedTruckers';
import { useUnlockSuggestedTruckersEvents } from 'hooks/useUnlockSuggestedTruckersEvents';
import { brlCurrencyFormatter } from 'utils/brlCurrencyFormatter';

const DrawerCheckoutMF = lazy(() => import('userPlan/CheckoutExtraProducts'));

const DrawerCheckout = () => {
  const { isOpen, closeDrawer, isLoading, isAllowed } = useDrawerCheckout();
  const fallbackRender = (): JSX.Element => null;

  const { price, lockedTruckersAmount } = usePayPerUseExtraTruckers();
  const { fetchPurchaseExtraSuggestedTruckers } = usePurchaseExtraSuggestedTruckers();
  const { sendUnlockSuggestedTruckersEvent } = useUnlockSuggestedTruckersEvents();

  const handleClose = () => {
    sendUnlockSuggestedTruckersEvent('cancel');
    closeDrawer();
  };

  const handleConfirm = () => {
    const consumptionType = 'paid';

    sendUnlockSuggestedTruckersEvent('button-confirm', consumptionType);
    fetchPurchaseExtraSuggestedTruckers();
    closeDrawer();
  };

  const products = {
    trucker: {
      name: `Desbloquear ${lockedTruckersAmount} motoristas dessa lista`,
      description: `O valor desse desbloqueio é de ${brlCurrencyFormatter(
        price
      )} e será cobrado na sua próxima fatura de extras.`,
      price,
    },
  };

  return (
    <ErrorBoundary
      onReset={() => null}
      fallbackRender={fallbackRender}
      data-testid="error-boundary"
      onError={() => null}
    >
      <Suspense fallback={null}>
        <DrawerCheckoutMF
          isOpen={isOpen}
          isLoading={isLoading}
          isError={false}
          isAllowed={isAllowed}
          onClose={handleClose}
          onConfirm={handleConfirm}
          onRetry={handleConfirm}
          product={products.trucker}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

export { DrawerCheckout };
